<script setup lang="ts">
import { FieldParagraphLinklistFieldLinks, Maybe, ParagraphLinklist } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphLinklist
}>()

const items =
  props.entity.fieldLinks?.map((item: Maybe<FieldParagraphLinklistFieldLinks>, index) => {
    return {
      id: index,
      link: {
        text: item?.title || '',
        url: item?.url?.path || '',
        target: item?.options?.attributes?.target || '',
      },
    }
  }) || []
</script>

<template>
  <Section>
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <h2 v-if="entity?.fieldTitle">{{ entity?.fieldTitle }}</h2>
      <LinkList :items="items" />
    </div>
  </Section>
</template>
